(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-blog-carousel]');
    if (!root) return;
    var track = root.querySelector('[data-blog-carousel-track]');
    var slides = Array.from(root.querySelectorAll('[data-blog-carousel-slide]'));
    var dots = root.querySelectorAll('[data-blog-carousel-dot]');
    var prev = root.querySelector('[data-blog-carousel-prev]');
    var next = root.querySelector('[data-blog-carousel-next]');
    var current = 0;
    var total = slides.length;
    if (total < 2) return;
    var interval;

    function goTo(i) {
      current = i;
      track.style.transform = 'translateX(-' + current * 100 + '%)';
      dots.forEach(function (d, idx) {
        d.classList.toggle('blog-carousel__dot--active', idx === current);
      });
    }
    function nextSlide() {
      goTo((current + 1) % total);
    }
    function prevSlide() {
      goTo((current - 1 + total) % total);
    }
    function startAuto() {
      stopAuto();
      interval = setInterval(nextSlide, 5000);
    }
    function stopAuto() {
      clearInterval(interval);
    }

    if (prev)
      prev.addEventListener('click', function () {
        prevSlide();
        startAuto();
      });
    if (next)
      next.addEventListener('click', function () {
        nextSlide();
        startAuto();
      });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        goTo(i);
        startAuto();
      });
    });
    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);
    startAuto();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["case-studies"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-case-studies]');
    if (!root) return;

    var track = root.querySelector('[data-cs-track]');
    var prevBtn = root.querySelector('[data-cs-prev]');
    var nextBtn = root.querySelector('[data-cs-next]');
    var realSlides = Array.from(root.querySelectorAll('[data-cs-slide]'));
    var total = realSlides.length;
    if (total === 0) return;

    // ── Clone first & last so the loop looks seamless ─────
    var firstClone = realSlides[0].cloneNode(true);
    firstClone.setAttribute('data-cs-clone', '');
    var lastClone = realSlides[total - 1].cloneNode(true);
    lastClone.setAttribute('data-cs-clone', '');

    track.insertBefore(lastClone, realSlides[0]);
    track.appendChild(firstClone);

    var allSlides = Array.from(root.querySelectorAll('[data-cs-slide]'));
    var current = 1;       // real slide 0
    var busy = false;

    function cardW()  { return allSlides[0] ? allSlides[0].offsetWidth : 400; }
    function gap()    { return parseFloat(getComputedStyle(track).gap) || 24; }
    function offsetAt(i) { return -(i * (cardW() + gap())); }
    function realIdx() {
      if (current === 0) return total - 1;
      if (current === total + 1) return 0;
      return current - 1;
    }

    function apply(animate) {
      track.style.transition = animate
        ? 'transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1)'
        : 'none';
      track.style.transform = 'translateX(' + offsetAt(current) + 'px)';
    }

    function updateUI() {
      var ri = realIdx();
      root.querySelectorAll('[data-cs-dot]').forEach(function(d, i) {
        d.classList.toggle('case-studies__dot--active', i === ri);
      });
      allSlides.forEach(function(s, i) {
        s.classList.toggle('is-dimmed', i !== current);
      });
    }

    // ── Seamless wrap after each animation ends ──────────
    track.addEventListener('transitionend', function() {
      busy = false;
      if (current === 0) {
        // Landed on the prepended last-clone → jump to real last
        current = total;
        apply(false);
        updateUI();
      } else if (current === total + 1) {
        // Landed on the appended first-clone → jump to real first
        current = 1;
        apply(false);
        updateUI();
      }
    });

    // ── Move one step ────────────────────────────────────
    function step(dir) {
      if (busy) return;
      busy = true;
      current += dir;
      apply(true);
      updateUI();
    }

    prevBtn.addEventListener('click', function() { step(-1); });
    nextBtn.addEventListener('click', function() { step(1); });

    // ── Dots ─────────────────────────────────────────────
    root.querySelectorAll('[data-cs-dot]').forEach(function(d) {
      d.addEventListener('click', function() {
        if (busy) return;
        busy = true;
        current = parseInt(d.getAttribute('data-cs-dot'), 10) + 1;
        apply(true);
        updateUI();
      });
    });

    // ── Touch swipe ──────────────────────────────────────
    var touchX = 0;
    track.addEventListener('touchstart', function(e) { touchX = e.touches[0].clientX; });
    track.addEventListener('touchend', function(e) {
      if (busy) return;
      var diff = touchX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) step(diff > 0 ? 1 : -1);
    });

    // ── Init ─────────────────────────────────────────────
    apply(false);
    updateUI();

    // ── Resize ───────────────────────────────────────────
    var resizeT;
    window.addEventListener('resize', function() {
      clearTimeout(resizeT);
      resizeT = setTimeout(function() { apply(false); updateUI(); }, 150);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-collection-root]');
    if (!root) return;

    var PER_PAGE = parseInt(root.getAttribute('data-per-page')) || 20;
    var panels = root.querySelectorAll('[data-collection-panel]');
    var prevBtn = root.querySelector('[data-collection-prev]');
    var nextBtn = root.querySelector('[data-collection-next]');
    var currentEl = root.querySelector('[data-collection-current]');
    var totalEl = root.querySelector('[data-collection-total]');
    var searchInputs = root.querySelectorAll('[data-collection-search]');
    var paginationEl = root.querySelector('[data-collection-pagination]');
    var emptyEl = root.querySelector('.empty-state');

    var activePanel = null;
    var activeGrid = null;
    var currentPage = 0;
    var totalPages = 1;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    /* ── Accordion toggle ── */
    var toggles = root.querySelectorAll('[data-accordion-toggle]');
    toggles.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var section = btn.closest('[data-accordion-section]');
        if (section) section.classList.toggle('is-open');
      });
    });

    /* ── Filter helpers ── */
    function getSearchTerm() {
      // Read from whichever search input has a value (desktop or mobile)
      for (var s = 0; s < searchInputs.length; s++) {
        var v = searchInputs[s].value.trim();
        if (v) return v.toLowerCase();
      }
      return '';
    }

    function getActiveTags() {
      if (!activeGrid) return [];
      var cbs = activeGrid.parentNode.querySelectorAll('[data-tag-filter]:checked');
      if (!cbs.length) cbs = root.querySelectorAll('[data-tag-filter]:checked');
      var tags = [];
      cbs.forEach(function(cb) { tags.push(cb.value); });
      return tags;
    }

    function getTagCheckboxes() {
      return root.querySelectorAll('[data-tag-filter]');
    }

    function matchesFilter(wrap) {
      var search = getSearchTerm();
      var tags = getActiveTags();
      if (search) {
        var title = (wrap.getAttribute('data-product-title') || '').toLowerCase();
        if (title.indexOf(search) === -1) return false;
      }
      if (tags.length) {
        var ptags = (wrap.getAttribute('data-product-tags') || '').split(',');
        for (var t = 0; t < tags.length; t++) {
          if (ptags.indexOf(tags[t]) === -1) return false;
        }
      }
      return true;
    }

    function applyFilter() {
      currentPage = 0;
      var visible = 0;
      var wraps = activeGrid ? activeGrid.querySelectorAll('.collection-product-wrap') : [];
      wraps.forEach(function(w) { if (matchesFilter(w)) visible++; });
      totalPages = Math.max(1, Math.ceil(visible / PER_PAGE));
      if (visible === 0) {
        if (paginationEl) paginationEl.style.display = 'none';
        if (emptyEl) emptyEl.classList.add('empty-state--visible');
      } else {
        if (paginationEl) paginationEl.style.display = '';
        if (emptyEl) emptyEl.classList.remove('empty-state--visible');
      }
      showPage();
    }

    function resetFilters() {
      // Clear all search inputs (desktop + mobile)
      searchInputs.forEach(function(inp) { inp.value = ''; });
      var cbs = getTagCheckboxes();
      cbs.forEach(function(cb) { cb.checked = false; });
      currentPage = 0;
      // Use applyFilter to correctly manage empty state visibility
      applyFilter();
    }

    /* ── Render ── */
    function render() {
      if (currentEl) currentEl.textContent = pad(currentPage + 1);
      if (totalEl) totalEl.textContent = pad(totalPages);
      if (prevBtn) prevBtn.disabled = (currentPage <= 0);
      if (nextBtn) nextBtn.disabled = (currentPage >= totalPages - 1);
    }

    function showPage() {
      if (!activeGrid) return;
      var wraps = activeGrid.querySelectorAll('.collection-product-wrap');
      // First, reset all wraps to visible so we can re-filter properly
      wraps.forEach(function(w) { w.style.display = ''; });
      // Then apply search/tag filters
      var visibleWraps = [];
      wraps.forEach(function(w) {
        if (matchesFilter(w)) { visibleWraps.push(w); }
        else { w.style.display = 'none'; }
      });
      // Pagination: hide all, then show only current page's slice
      var start = currentPage * PER_PAGE;
      var end = Math.min(start + PER_PAGE, visibleWraps.length);
      visibleWraps.forEach(function(w, vi) {
        w.style.display = (vi >= start && vi < end) ? '' : 'none';
      });
      render();
    }

    /* ── Panel switching ── */
    function activatePanel(panelId) {
      var panel = root.querySelector('[data-collection-panel="' + panelId + '"]');
      if (!panel) return;
      panels.forEach(function(p) { p.classList.remove('collection-panel--active'); });
      panel.classList.add('collection-panel--active');
      activePanel = panel;
      activeGrid = panel.querySelector('.collection-grid');
      currentPage = 0;
      if (activeGrid) {
        var wraps = activeGrid.querySelectorAll('.collection-product-wrap');
        totalPages = Math.max(1, Math.ceil(wraps.length / PER_PAGE));
        if (wraps.length === 0) {
          if (paginationEl) paginationEl.style.display = 'none';
          if (emptyEl) emptyEl.classList.add('empty-state--visible');
        } else {
          if (paginationEl) paginationEl.style.display = '';
          if (emptyEl) emptyEl.classList.remove('empty-state--visible');
        }
      } else {
        totalPages = 1;
        if (paginationEl) paginationEl.style.display = 'none';
        if (emptyEl) emptyEl.classList.add('empty-state--visible');
      }
      if (getSearchTerm() || getActiveTags().length) {
        applyFilter();
      } else {
        showPage();
      }
    }

    /* ── Event delegation on root ── */
    root.addEventListener('change', function(e) {
      var target = e.target;
      if (target.hasAttribute('data-category-radio')) {
        if (target.checked) {
          activatePanel(target.value);
          closeDrawer();
        }
      }
      if (target.hasAttribute('data-tag-filter')) {
        applyFilter();
      }
    });

    var searchDebounce;
    root.addEventListener('input', function(e) {
      if (e.target.hasAttribute('data-collection-search')) {
        // Sync value across both search inputs (desktop + mobile)
        var val = e.target.value;
        searchInputs.forEach(function(inp) {
          if (inp !== e.target) inp.value = val;
        });
        clearTimeout(searchDebounce);
        searchDebounce = setTimeout(applyFilter, 200);
      }
    });

    root.addEventListener('click', function(e) {
      var target = e.target;
      if (target.closest('[data-collection-reset]')) {
        resetFilters();
      }
      if (target.closest('[data-collection-prev]') && currentPage > 0) {
        currentPage--; showPage();
      }
      if (target.closest('[data-collection-next]') && currentPage < totalPages - 1) {
        currentPage++; showPage();
      }
      /* Mobile drawer */
      if (target.closest('[data-mobile-filter-toggle]')) {
        openDrawer();
      }
      if (target.closest('[data-mobile-filter-close]') || target.closest('[data-filter-drawer-backdrop]')) {
        closeDrawer();
      }
    });

    /* ── Drawer ── */
    var sidebar = root.querySelector('[data-collection-sidebar]');
    var backdrop = root.querySelector('[data-filter-drawer-backdrop]');

    function openDrawer() {
      if (sidebar) sidebar.classList.add('is-drawer-open');
      if (backdrop) backdrop.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (sidebar) sidebar.classList.remove('is-drawer-open');
      if (backdrop) backdrop.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    /* ── Init: URL parameter support ── */
    var params = new URLSearchParams(window.location.search);
    var categoryParam = params.get('category');

    if (categoryParam) {
      var targetRadio = root.querySelector('[data-category-radio][value="' + categoryParam + '"]');
      if (targetRadio) {
        targetRadio.checked = true;
        activatePanel(categoryParam);
      }
    }

    /* Fallback: checked radio or first radio */
    if (!activePanel) {
      var checkedRadio = root.querySelector('[data-category-radio]:checked');
      if (checkedRadio) {
        activatePanel(checkedRadio.value);
      } else {
        var firstRadio = root.querySelector('[data-category-radio]');
        if (firstRadio) { firstRadio.checked = true; activatePanel(firstRadio.value); }
      }
    }

    /* ── Compare tray logic ── */
    var CKEY = 'supervision_compare';
    var tray = root.querySelector('[data-compare-tray]');
    var slots = root.querySelectorAll('[data-compare-tray] [data-compare-slots] > .compare-tray__slot');
    var clearBtn = root.querySelector('[data-compare-clear]');
    var goBtn = root.querySelector('[data-compare-go]');
    var MAX = 4;

    function getCompareList() {
      try { return JSON.parse(localStorage.getItem(CKEY) || '[]'); } catch(e) { return []; }
    }
    function saveCompareList(list) {
      localStorage.setItem(CKEY, JSON.stringify(list));
      updateTray();
      updateCheckboxes();
    }
    function updateTray() {
      if (!tray) return;
      var list = getCompareList();
      tray.classList.toggle('compare-tray--visible', list.length > 0);
      var slotEls = tray.querySelectorAll('[data-compare-slot]');
      slotEls.forEach(function(s, i) {
        if (i < list.length) {
          var item = list[i];
          s.classList.remove('compare-tray__slot--empty');
          var html = '<button class="compare-tray__slot-remove" data-compare-remove="' + item.handle + '">&times;</button>';
          if (item.img) html += '<img src="' + item.img + '" alt="' + item.title + '">';
          html += '<span class="compare-tray__slot-name">' + item.title + '</span>';
          s.innerHTML = html;
        } else {
          s.innerHTML = '';
          s.classList.add('compare-tray__slot--empty');
        }
      });
      if (goBtn) goBtn.textContent = 'Compare' + (list.length > 1 ? ' (' + list.length + ')' : '');
      if (goBtn && list.length < 2) goBtn.style.opacity = '0.35';
      else if (goBtn) goBtn.style.opacity = '1';
    }
    function updateCheckboxes() {
      var list = getCompareList();
      var handles = list.map(function(i) { return i.handle; });
      var allCbs = root.querySelectorAll('[data-compare-toggle]');
      allCbs.forEach(function(cb) {
        cb.checked = handles.indexOf(cb.value) !== -1;
      });
    }
    function addToCompare(cb) {
      var list = getCompareList();
      if (list.length >= MAX) return false;
      list.push({ handle: cb.value, title: cb.getAttribute('data-compare-title'), img: cb.getAttribute('data-compare-img') });
      saveCompareList(list);
      return true;
    }
    function removeFromCompare(handle) {
      var list = getCompareList().filter(function(i) { return i.handle !== handle; });
      saveCompareList(list);
    }

    root.addEventListener('change', function(e) {
      var cb = e.target;
      if (!cb.hasAttribute('data-compare-toggle')) return;
      if (cb.checked) {
        if (!addToCompare(cb)) { cb.checked = false; return; }
      } else {
        removeFromCompare(cb.value);
      }
    });

    root.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-compare-remove]');
      if (btn) {
        e.preventDefault();
        removeFromCompare(btn.getAttribute('data-compare-remove'));
      }
      if (e.target.hasAttribute('data-compare-clear')) {
        saveCompareList([]);
      }
    });

    updateTray();
    updateCheckboxes();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-page"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var CKEY = 'supervision_compare';
    var root = document.querySelector('[data-compare-page]');
    if (!root) return;

    var emptyEl = root.querySelector('[data-compare-empty]');
    var tableEl = root.querySelector('[data-compare-table]');
    var countEl = root.querySelector('[data-compare-count]');
    var labelSpec = root.getAttribute('data-label-spec') || 'Specification';
    var labelRemove = root.getAttribute('data-label-remove') || 'Remove';
    var labelDesc = root.getAttribute('data-label-description') || 'Description';

    var list = [];
    try { list = JSON.parse(localStorage.getItem(CKEY) || '[]'); } catch(e) {}

    if (!list.length) {
      emptyEl.style.display = '';
      return;
    }

    if (countEl) {
      var tpl = countEl.getAttribute('data-compare-count-tpl');
      tpl = tpl.replace('{count}', list.length);
      tpl = tpl.replace('{plural}', list.length > 1 ? 's' : '');
      countEl.textContent = tpl;
    }

    var fetches = list.map(function(item) {
      return fetch('/products/' + item.handle + '.json')
        .then(function(r) { return r.json(); })
        .then(function(data) { return data.product; })
        .catch(function() { return null; });
    });

    var html = '<table><thead><tr><th>' + labelSpec + '</th>';
    list.forEach(function(item) {
      html += '<th><img src="' + (item.img || '') + '" alt="' + item.title + '" loading="lazy" data-cp-img><span class="cp-name">' + item.title + '</span><button class="cp-remove" data-cp-remove="' + item.handle + '">' + labelRemove + '</button></th>';
    });
    html += '</tr></thead><tbody>';

    Promise.all(fetches).then(function(products) {
      // Dynamically discover all spec keys from the first product's description
      var allKeys = [];
      var firstProduct = products.find(function(p) { return p && p.body_html; });
      if (firstProduct) {
        var thRe = /<th[^>]*>([\s\S]*?)<\/th>/gi;
        var m;
        while ((m = thRe.exec(firstProduct.body_html)) !== null) {
          var key = m[1].replace(/<[^>]+>/g, '').trim();
          if (key && allKeys.indexOf(key) === -1) allKeys.push(key);
        }
      }

      // For each discovered key, extract the value from each product
      allKeys.forEach(function(key) {
        html += '<tr><td>' + key + '</td>';
        list.forEach(function(item, idx) {
          var p = products[idx];
          var val = extractSpec(p, key);
          html += '<td>' + (val || '<span style="color:#ccc;">—</span>') + '</td>';
        });
        html += '</tr>';
      });

      // If no specs found via table parsing, show raw descriptions
      if (allKeys.length === 0) {
        html += '<tr><td>' + labelDesc + '</td>';
        list.forEach(function(item, idx) {
          var p = products[idx];
          var desc = p && p.body_html ? p.body_html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().substring(0, 300) + '…' : '—';
          html += '<td>' + desc + '</td>';
        });
        html += '</tr>';
      }

      html += '</tbody></table>';
      tableEl.innerHTML = html;

      tableEl.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-cp-remove]');
        if (btn) {
          var h = btn.getAttribute('data-cp-remove');
          var newList = list.filter(function(i) { return i.handle !== h; });
          localStorage.setItem(CKEY, JSON.stringify(newList));
          location.reload();
        }
      });

      // Hide broken product images (replaces inline onerror)
      tableEl.addEventListener('error', function(e) {
        var img = e.target.closest('[data-cp-img]');
        if (img) img.style.display = 'none';
      }, true);
    });

    function extractSpec(product, key) {
      if (!product || !product.body_html) return null;
      var body = product.body_html;
      var kesc = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      // Match <th>key</th><td>value</td> pattern
      var re = new RegExp(kesc + '<\\/th>\\s*<td[^>]*>([\\s\\S]*?)<\\/td>', 'i');
      var m = body.match(re);
      if (m) return m[1].replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim();
      return null;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function() {
    var toggles = document.querySelectorAll('[data-footer-toggle]');
    toggles.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', !expanded);
        var body = btn.nextElementSibling;
        if (body) {
          if (!expanded) {
            body.setAttribute('data-open', '');
          } else {
            body.removeAttribute('data-open');
          }
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function initHeader() {
    var header = document.querySelector('[data-header]');
    // Retry if header not in DOM yet (Shopify dynamic section injection)
    if (!header) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initHeader);
      } else {
        setTimeout(initHeader, 50);
      }
      return;
    }

    // ── State ──────────────────────────────────────────────
    let activeDropdown = null;
    let activeChild = {};
    let searchOpen = false;
    let localeOpen = false;
    let mobileOpen = false;
    let navHovered = false;

    // ── DOM refs (cached lazily via delegation — no querySelectorAll at init) ─
    function getSearchPanel() { return header.querySelector('[data-panel="search"]'); }
    function getLocaleDrawer() { return header.querySelector('[data-panel="locale"]'); }
    function getMobileOverlay() { return header.querySelector('[data-panel="mobile-menu"]'); }
    function getDivider() { return header.querySelector('.header__divider'); }
    function getBackdrop() { return header.querySelector('.header__backdrop'); }
    function getDropdownBackdrop() { return header.querySelector('.header__dropdown-backdrop'); }

    // ── Scroll-aware header transparency ─────────────────
    var isSolidMode = header.hasAttribute('data-header-solid');

    // ── Initialize solid mode: ensure correct classes on page load ─
    if (isSolidMode) {
      header.classList.add('header--solid');
      header.classList.remove('header--transparent', 'header--overlay');
    }

    var isScrolled = window.scrollY > 50;

    function onScroll() {
      if (isSolidMode) return;
      var scrolled = window.scrollY > 50;
      if (scrolled !== isScrolled) {
        isScrolled = scrolled;
        updateHeaderStyle();
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    // ── Update header visual state ────────────────────────
    function updateHeaderStyle() {
      if (!isSolidMode) {
        const isActive = isScrolled || navHovered || activeDropdown !== null || searchOpen || localeOpen || mobileOpen;
        header.classList.toggle('header--solid', isActive);
        header.classList.toggle('header--transparent', !isActive);
      }

      const ddBackdrop = getDropdownBackdrop();
      if (ddBackdrop) {
        ddBackdrop.classList.toggle('is-visible', activeDropdown !== null || searchOpen);
      }

      const divider = getDivider();
      if (divider) {
        divider.classList.toggle('is-visible', activeDropdown !== null || searchOpen || localeOpen);
      }
    }

    // ── Close all dropdowns ───────────────────────────────
    function closeAllDropdowns() {
      activeDropdown = null;
      header.querySelectorAll('[data-header-dropdown]').forEach(function(d) { d.classList.remove('is-open'); });
      header.querySelectorAll('[data-header-nav-trigger]').forEach(function(t) { t.classList.remove('header__nav-item--active'); });
      updateHeaderStyle();
    }

    // ── Open a specific dropdown ──────────────────────────
    function openDropdown(index) {
      var targetDropdown = header.querySelector('[data-header-dropdown-index="' + index + '"]');

      if (!targetDropdown) {
        closeAllDropdowns();
        header.querySelectorAll('[data-header-nav-trigger]').forEach(function(t) {
          t.classList.toggle('header__nav-item--active', t.getAttribute('data-header-nav-index') === String(index));
        });
        updateHeaderStyle();
        return;
      }

      header.querySelectorAll('[data-header-dropdown]').forEach(function(d) {
        d.classList.toggle('is-open', d === targetDropdown);
      });
      header.querySelectorAll('[data-header-nav-trigger]').forEach(function(t) {
        t.classList.toggle('header__nav-item--active', t.getAttribute('data-header-nav-index') === String(index));
      });

      activeDropdown = index;
      var main = targetDropdown.querySelector('.header__dropdown-main');
      var firstChild = main ? parseInt(main.getAttribute('data-first-child'), 10) : 0;
      if (isNaN(firstChild) || firstChild < 0) firstChild = 0;
      activateChildPanel(index, firstChild);
      updateHeaderStyle();
    }

    // ── Activate child panel in sidebar dropdown ──────────
    function activateChildPanel(dropdownIndex, childIndex) {
      if (!activeChild[dropdownIndex]) activeChild[dropdownIndex] = {};
      activeChild[dropdownIndex].current = childIndex;

      header.querySelectorAll('[data-header-child-trigger]').forEach(function(btn) {
        var isMatch = btn.getAttribute('data-header-dropdown-index') === String(dropdownIndex)
                   && btn.getAttribute('data-header-child-index') === String(childIndex);
        btn.classList.toggle('header__dropdown-sidebar-item--active', isMatch);
      });

      header.querySelectorAll('[data-header-child-panel]').forEach(function(panel) {
        var isMatch = panel.getAttribute('data-header-dropdown-index') === String(dropdownIndex)
                   && panel.getAttribute('data-header-child-index') === String(childIndex);
        panel.classList.toggle('is-active', isMatch);
      });
    }

    // ── Toggle search panel ───────────────────────────────
    function toggleSearch() {
      searchOpen = !searchOpen;
      if (searchOpen) {
        closeAllDropdowns();
        closeLocale();
      }
      var sp = getSearchPanel();
      if (sp) sp.classList.toggle('is-open', searchOpen);
      updateHeaderStyle();
    }

    function closeSearch() {
      searchOpen = false;
      var sp = getSearchPanel();
      if (sp) sp.classList.remove('is-open');
      updateHeaderStyle();
    }

    // ── Toggle locale drawer ──────────────────────────────
    function toggleLocale() {
      localeOpen = !localeOpen;
      if (localeOpen) {
        closeAllDropdowns();
        closeSearch();
      }
      var ld = getLocaleDrawer();
      var bd = getBackdrop();
      if (ld) ld.classList.toggle('is-open', localeOpen);
      if (bd) bd.classList.toggle('is-open', localeOpen);
      updateHeaderStyle();
    }

    function closeLocale() {
      localeOpen = false;
      var ld = getLocaleDrawer();
      var bd = getBackdrop();
      if (ld) ld.classList.remove('is-open');
      if (bd) bd.classList.remove('is-open');
      updateHeaderStyle();
    }

    // ── Toggle mobile menu ────────────────────────────────
    function openMobile() {
      mobileOpen = true;
      var mo = getMobileOverlay();
      if (mo) mo.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      updateHeaderStyle();
    }

    function closeMobile() {
      mobileOpen = false;
      navHovered = false;
      var mo = getMobileOverlay();
      if (mo) mo.classList.remove('is-open');
      document.body.style.overflow = '';
      // Close other panels that may have been open from desktop view
      closeSearch();
      closeLocale();
      closeAllDropdowns();
      updateHeaderStyle();
    }

    // ── Toggle accordion ──────────────────────────────────
    function toggleAccordion(trigger) {
      var panel = trigger.parentElement.querySelector('[data-accordion-panel]');
      if (!panel) return;

      var isOpen = panel.classList.contains('is-open');
      panel.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', String(!isOpen));
    }

    // ═══════════════════════════════════════════════════════
    // Event delegation: all events bound on header, matched via data attributes
    // This ensures events work correctly even when child elements are injected into the DOM later
    // ═══════════════════════════════════════════════════════

    // ── Desktop nav: mouseenter / mouseleave ──────────────
    header.addEventListener('mouseenter', function() {
      navHovered = true;
      updateHeaderStyle();
    });

    header.addEventListener('mouseleave', function(e) {
      // Don't close if mouse moved into a dropdown panel or is still within the header
      if (e.relatedTarget && header.contains(e.relatedTarget)) return;
      var insideDropdown = e.relatedTarget && e.relatedTarget.closest && (
        e.relatedTarget.closest('[data-header-dropdown]') ||
        e.relatedTarget.closest('.header__dropdown')
      );
      if (insideDropdown) return;
      navHovered = false;
      closeAllDropdowns();
      updateHeaderStyle();
    });

    // ── Nav item hover (open dropdown) — delegation ───────
    header.addEventListener('mouseenter', function(e) {
      var trigger = e.target.closest('[data-header-nav-trigger]');
      if (!trigger) return;
      var index = trigger.getAttribute('data-header-nav-index');
      if (!index) return;
      // Don't reset if already open for this nav item
      if (activeDropdown === index) return;
      closeSearch();
      openDropdown(index);
    }, true); // capture phase for earlier response

    // ── Sidebar child hover — delegation ──────────────────
    header.addEventListener('mouseenter', function(e) {
      var btn = e.target.closest('[data-header-child-trigger]');
      if (!btn) return;
      var dIdx = parseInt(btn.getAttribute('data-header-dropdown-index'), 10);
      var cIdx = parseInt(btn.getAttribute('data-header-child-index'), 10);
      if (!isNaN(dIdx) && !isNaN(cIdx)) activateChildPanel(dIdx, cIdx);
    }, true);

    // ── Click delegation: actions, toggles, accordions ────
    header.addEventListener('click', function(e) {
      var target = e.target;

      // Search toggle
      if (target.closest('[data-action="search"]')) {
        e.stopPropagation();
        toggleSearch();
        return;
      }
      // Locale toggle
      if (target.closest('[data-action="locale"]')) {
        e.stopPropagation();
        toggleLocale();
        return;
      }

      // Locale close
      if (target.closest('[data-action="locale-close"]')) {
        e.stopPropagation();
        closeLocale();
        return;
      }

      // Mobile open
      if (target.closest('[data-action="mobile-open"]')) {
        e.stopPropagation();
        openMobile();
        return;
      }

      // Mobile close
      if (target.closest('[data-action="mobile-close"]')) {
        e.stopPropagation();
        closeMobile();
        return;
      }

      // Close mobile links
      if (target.closest('[data-close-mobile]')) {
        closeMobile();
        return;
      }

      // Close panels from suggestion links
      if (target.closest('[data-close-panels]')) {
        closeSearch();
        closeAllDropdowns();
        closeLocale();
        return;
      }

      // Accordion trigger
      var accordionBtn = target.closest('[data-accordion-trigger]');
      if (accordionBtn && header.contains(accordionBtn)) {
        e.preventDefault();
        toggleAccordion(accordionBtn);
        return;
      }
    });

    // ── Click outside panels (document level) ──────────────
    document.addEventListener('click', function(e) {
      if (searchOpen) {
        var sp = getSearchPanel();
        if (sp && !sp.contains(e.target) && !e.target.closest('[data-action="search"]')) {
          closeSearch();
        }
      }
      if (localeOpen) {
        var ld = getLocaleDrawer();
        if (ld && !ld.contains(e.target) && !e.target.closest('[data-action="locale"]')) {
          closeLocale();
        }
      }
      if (mobileOpen) {
        var mo = getMobileOverlay();
        if (mo && e.target === mo) {
          closeMobile();
        }
      }
    });

    // ── Backdrop click closes locale ──────────────────────
    header.addEventListener('click', function(e) {
      if (e.target.closest('.header__backdrop')) {
        closeLocale();
      }
    });

    // ── Keyboard (Escape) ─────────────────────────────────
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        if (searchOpen) closeSearch();
        if (localeOpen) closeLocale();
        if (mobileOpen) closeMobile();
        closeAllDropdowns();
      }
    });

    // ── Initialize accordion aria-expanded ────────────────
    header.querySelectorAll('[data-accordion-trigger]').forEach(function(trigger) {
      if (!trigger.hasAttribute('aria-expanded')) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-hero-slider]');
    if (!root) return;
    var slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
    if (slides.length < 2) return;
    var dots = root.querySelectorAll('[data-hero-dot]');
    var prevBtn = root.querySelector('[data-hero-prev]');
    var nextBtn = root.querySelector('[data-hero-next]');
    var current = 0;
    var total = slides.length;
    var interval;
    var paused = false;

    function goTo(index, dir) {
      if (index === current) return;
      var old = slides[current];
      var next = slides[index];
      // Remove all transition classes
      slides.forEach(function(s) { s.classList.remove('hero-banner__slide--active', 'hero-banner__slide--exit-left', 'hero-banner__slide--exit-right'); });
      // Exit current
      old.classList.add(dir === 'prev' ? 'hero-banner__slide--exit-right' : 'hero-banner__slide--exit-left');
      // Enter next
      next.classList.add('hero-banner__slide--active');
      current = index;
      // Update dots
      dots.forEach(function(d, i) { d.classList.toggle('hero-banner__dot--active', i === current); });
    }

    function next() { goTo((current + 1) % total, 'next'); }
    function prev() { goTo((current - 1 + total) % total, 'prev'); }

    function startAuto() { clearInterval(interval); interval = setInterval(next, 5000); }
    function stopAuto() { clearInterval(interval); }

    if (prevBtn) prevBtn.addEventListener('click', function() { prev(); startAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { next(); startAuto(); });
    dots.forEach(function(d) {
      d.addEventListener('click', function() { var i = parseInt(this.getAttribute('data-hero-dot')); goTo(i, i > current ? 'next' : 'prev'); startAuto(); });
    });
    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);
    root.addEventListener('touchstart', stopAuto);
    root.addEventListener('touchend', function() { setTimeout(startAuto, 2000); });

    startAuto();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = (document.currentScript && document.currentScript.closest('.product-showcase'))
      || document.querySelector('[data-product-showcase-root]');
    if (!section) return;

    var chips = section.querySelectorAll('.product-chips__chip');
    var panels = section.querySelectorAll('.product-carousel__panel');
    var prevBtn = section.querySelector('[data-carousel-prev]');
    var nextBtn = section.querySelector('[data-carousel-next]');
    var currentEl = section.querySelector('.product-carousel__current');
    var totalEl = section.querySelector('.product-carousel__total');
    var paginationEl = section.querySelector('[data-carousel-pagination]');

    // ── Page-based state ──
    var activeTrack = null;
    var activeViewport = null;
    var currentPage = 0;
    var totalPages = 1;
    var cardsPerPage = 1;
    var totalCards = 0;
    var isTransitioning = false;
    var wheelAccumulator = 0;
    var transitionTimer = null;
    var resizeTimer = null;

    // ── Touch swipe state ──
    var touchStartX = 0;
    var touchStartY = 0;
    var touchStartTime = 0;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    /* ════════════════════════════════════════════
       Page navigation: translate the track
       ════════════════════════════════════════════ */
    function goToPage(page, animate) {
      if (!activeTrack || totalCards === 0) return;

      var cards = activeTrack.querySelectorAll('.product-card-hover');
      if (!cards.length) return;

      // Measure exact offset using subpixel-precise rects to the target page's first card
      var offset = 0;
      var startIndex = page * cardsPerPage;
      if (startIndex > 0 && startIndex <= cards.length) {
        var trackLeft = activeTrack.getBoundingClientRect().left;
        var targetLeft = cards[startIndex].getBoundingClientRect().left;
        offset = targetLeft - trackLeft;
      }

      if (animate) {
        isTransitioning = true;
        activeTrack.classList.add('product-showcase__track--animating');
        activeTrack.classList.remove('product-showcase__track--instant');
      } else {
        activeTrack.classList.add('product-showcase__track--instant');
        activeTrack.classList.remove('product-showcase__track--animating');
      }

      activeTrack.style.transform = 'translateX(-' + offset + 'px)';

      // Safety: clear transition lock after 500ms even if transitionend misses
      clearTimeout(transitionTimer);
      if (animate) {
        transitionTimer = setTimeout(function() {
          isTransitioning = false;
          activeTrack.classList.remove('product-showcase__track--animating');
        }, 500);
      }
    }

    /* ════════════════════════════════════════════
       Layout calculation
       ════════════════════════════════════════════ */
    function calculateLayout() {
      if (!activeTrack || !activeViewport) return;

      var cards = activeTrack.querySelectorAll('.product-card-hover');
      totalCards = cards.length;
      var emptyEl = activeTrack.querySelector('.empty-state');

      // Empty state
      if (totalCards === 0) {
        if (emptyEl) emptyEl.classList.add('empty-state--visible');
        if (paginationEl) paginationEl.style.display = 'none';
        totalPages = 1;
        currentPage = 0;
        render();
        return;
      }

      if (emptyEl) emptyEl.classList.remove('empty-state--visible');

      // Count how many cards actually fit in the viewport using subpixel-precise rects
      cardsPerPage = 0;
      var viewportRect = activeViewport.getBoundingClientRect();
      for (var i = 0; i < cards.length; i++) {
        var cardRight = cards[i].getBoundingClientRect().right;
        if (cardRight <= viewportRect.right + 1) {
          cardsPerPage++;
        } else {
          break;
        }
      }
      cardsPerPage = Math.max(1, cardsPerPage);
      totalPages = Math.max(1, Math.ceil(totalCards / cardsPerPage));

      // Hide pagination for single-page
      if (totalPages <= 1) {
        if (paginationEl) paginationEl.style.display = 'none';
      } else {
        if (paginationEl) paginationEl.style.display = '';
      }

      // Clamp current page to valid range
      currentPage = Math.max(0, Math.min(currentPage, totalPages - 1));

      goToPage(currentPage, false);
      render();
    }

    /* ════════════════════════════════════════════
       Render: update pagination UI
       ════════════════════════════════════════════ */
    function render() {
      if (currentEl) currentEl.textContent = pad(currentPage + 1);
      if (totalEl) totalEl.textContent = pad(totalPages);
      if (prevBtn) prevBtn.disabled = (currentPage <= 0);
      if (nextBtn) nextBtn.disabled = (currentPage >= totalPages - 1);
    }

    /* ════════════════════════════════════════════
       Switch between category panels
       ════════════════════════════════════════════ */
    function activatePanel(panelId) {
      var targetPanel = section.querySelector('[data-carousel-panel="' + panelId + '"]');
      if (!targetPanel) return;

      panels.forEach(function(p) { p.classList.remove('product-carousel__panel--active'); });
      targetPanel.classList.add('product-carousel__panel--active');

      chips.forEach(function(c) {
        c.classList.toggle('product-chips__chip--active', c.getAttribute('data-chip') === panelId);
      });

      activeTrack = targetPanel.querySelector('[data-scroll-track]');
      activeViewport = targetPanel.querySelector('[data-product-viewport]');

      // Reset page state
      currentPage = 0;
      wheelAccumulator = 0;
      isTransitioning = false;
      if (activeTrack) activeTrack.style.transform = 'translateX(0)';

      calculateLayout();
    }

    /* ════════════════════════════════════════════
       Chip click handlers
       ════════════════════════════════════════════ */
    chips.forEach(function(chip) {
      chip.addEventListener('click', function() {
        activatePanel(chip.getAttribute('data-chip'));
      });
    });

    /* ── Chips row: redirect vertical wheel to horizontal scroll ── */
    var chipsRow = section.querySelector('[data-product-chips]');
    if (chipsRow) {
      chipsRow.addEventListener('wheel', function(e) {
        e.preventDefault();
        chipsRow.scrollBy({ left: e.deltaY, behavior: 'auto' });
      }, { passive: false });
    }

    /* ════════════════════════════════════════════
       Arrow button handlers
       ════════════════════════════════════════════ */
    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        if (isTransitioning || currentPage <= 0) return;
        currentPage--;
        goToPage(currentPage, true);
        render();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        if (isTransitioning || currentPage >= totalPages - 1) return;
        currentPage++;
        goToPage(currentPage, true);
        render();
      });
    }

    /* ════════════════════════════════════════════
       Viewport event handlers (per-viewport)
       ════════════════════════════════════════════ */
    section.querySelectorAll('[data-product-viewport]').forEach(function(viewport) {
      /* ── Wheel: lock page scroll, switch pages ── */
      viewport.addEventListener('wheel', function(e) {
        var panel = viewport.closest('.product-carousel__panel');
        if (!panel || !panel.classList.contains('product-carousel__panel--active')) return;

        var atFirst = currentPage <= 0;
        var atLast  = currentPage >= totalPages - 1;
        var scrollingDown = e.deltaY > 0;
        var scrollingUp   = e.deltaY < 0;

        // Release to native page scroll at boundaries
        if ((scrollingUp && atFirst) || (scrollingDown && atLast)) return;

        e.preventDefault();
        e.stopPropagation();

        if (isTransitioning || totalPages <= 1) return;

        // Accumulate wheel delta to debounce rapid scrolls (trackpads, magic mice)
        wheelAccumulator += e.deltaY;
        var THRESHOLD = 50;

        if (wheelAccumulator > THRESHOLD && !atLast) {
          wheelAccumulator = 0;
          currentPage++;
          goToPage(currentPage, true);
          render();
        } else if (wheelAccumulator < -THRESHOLD && !atFirst) {
          wheelAccumulator = 0;
          currentPage--;
          goToPage(currentPage, true);
          render();
        }
      }, { passive: false });

      /* ── Touch swipe ── */
      viewport.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchStartTime = Date.now();
      }, { passive: true });

      viewport.addEventListener('touchend', function(e) {
        if (isTransitioning) return;
        var dx = touchStartX - e.changedTouches[0].clientX;
        var dy = touchStartY - e.changedTouches[0].clientY;
        var dt = Date.now() - touchStartTime;

        // Only horizontal swipes (not vertical scrolls)
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 50 && dt < 300) {
          if (dx > 0 && currentPage < totalPages - 1) {
            currentPage++;
            goToPage(currentPage, true);
            render();
          } else if (dx < 0 && currentPage > 0) {
            currentPage--;
            goToPage(currentPage, true);
            render();
          }
        }
      });

      /* ── Keyboard navigation ── */
      viewport.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft' && !isTransitioning && currentPage > 0) {
          e.preventDefault();
          currentPage--;
          goToPage(currentPage, true);
          render();
        } else if (e.key === 'ArrowRight' && !isTransitioning && currentPage < totalPages - 1) {
          e.preventDefault();
          currentPage++;
          goToPage(currentPage, true);
          render();
        }
      });
    });

    /* ════════════════════════════════════════════
       Transition end handler (per-track)
       ════════════════════════════════════════════ */
    section.querySelectorAll('[data-scroll-track]').forEach(function(track) {
      track.addEventListener('transitionend', function(e) {
        if (e.target === track && e.propertyName === 'transform') {
          isTransitioning = false;
          track.classList.remove('product-showcase__track--animating');
        }
      });
    });

    /* ════════════════════════════════════════════
       Resize: debounced layout recalculation
       ════════════════════════════════════════════ */
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        calculateLayout();
      }, 200);
    });

    /* ════════════════════════════════════════════
       Init
       ════════════════════════════════════════════ */
    if (panels.length > 0) {
      activatePanel('all');
      var anyActive = section.querySelector('.product-chips__chip--active');
      if (!anyActive && chips.length > 0) {
        var firstId = chips[0].getAttribute('data-chip');
        if (firstId) activatePanel(firstId);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resources-download"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-resources-section]');
    if (!section) return;
    var sidebar = section.querySelector('[data-resources-sidebar]');
    var nav = section.querySelector('[data-resources-nav]');
    var list = section.querySelector('[data-resources-list]');
    var pag = section.querySelector('[data-resources-pagination]');
    var showing = section.querySelector('[data-resources-showing]');
    var empty = section.querySelector('[data-resources-empty]');
    var searchDesktop = section.querySelector('[data-resources-search]');
    var searchMobile = section.querySelector('[data-resources-search-mobile]');
    var resetDesktop = section.querySelector('[data-resources-search-reset]');
    var resetMobile = section.querySelector('[data-resources-search-reset-mobile]');
    var filterToggle = section.querySelector('[data-resources-filter-toggle]');
    var drawer = section.querySelector('[data-resources-drawer]');
    var drawerOverlay = section.querySelector('[data-resources-drawer-overlay]');
    var drawerClose = section.querySelector('[data-resources-drawer-close]');
    var drawerNav = section.querySelector('[data-resources-drawer-nav]');
    if (!list) return;

    var rows = [].slice.call(list.querySelectorAll('[data-resources-row]'));
    var perPageEl = section.querySelector('[data-resources-per-page]');
    var perPage = perPageEl ? parseInt(perPageEl.getAttribute('data-resources-per-page')) || 8 : 8;
    var currentFilter = 'all';
    var currentPage = 1;
    var searchQuery = '';

    function getFiltered() {
      return rows.filter(function(r) {
        var catMatch = currentFilter === 'all' || r.classList.contains('cat-' + currentFilter);
        if (!catMatch) return false;
        if (!searchQuery) return true;
        var title = (r.getAttribute('data-resources-title') || '').toLowerCase();
        var desc = (r.getAttribute('data-resources-desc') || '').toLowerCase();
        var q = searchQuery.toLowerCase();
        return title.indexOf(q) !== -1 || desc.indexOf(q) !== -1;
      });
    }

    function updateCounts() {
      function setCount(sel, n) {
        var els = section.querySelectorAll(sel);
        els.forEach(function(el) { el.textContent = n; });
      }
      setCount('[data-resources-count-all]', rows.length);
      var catBtns = section.querySelectorAll('[data-resources-filter]');
      catBtns.forEach(function(btn) {
        var f = btn.getAttribute('data-resources-filter');
        if (f === 'all') return;
        var n = rows.filter(function(r) { return r.classList.contains('cat-' + f); }).length;
        setCount('[data-resources-count="' + f + '"]', n);
      });
    }

    function renderPage() {
      var filtered = getFiltered();
      var total = filtered.length;
      var totalPages = Math.ceil(total / perPage) || 1;
      if (currentPage > totalPages) currentPage = totalPages;
      if (currentPage < 1) currentPage = 1;

      rows.forEach(function(r) { r.classList.add('resources-download__row--hidden'); });
      var start = (currentPage - 1) * perPage;
      var end = Math.min(start + perPage, total);
      for (var i = start; i < end; i++) { filtered[i].classList.remove('resources-download__row--hidden'); }

      if (showing) showing.textContent = total ? (start + 1) + '\u2013' + end + ' of ' + total : '';
      if (empty) {
        if (total === 0) {
          empty.classList.add('empty-state--visible');
        } else {
          empty.classList.remove('empty-state--visible');
        }
      }

      if (pag && totalPages > 1) {
        var html = '<button class="resources-download__page-btn' + (currentPage === 1 ? ' resources-download__page-btn--disabled' : '') + '">\u2190</button>';
        for (var p = 1; p <= totalPages; p++) { html += '<button class="resources-download__page-btn' + (p === currentPage ? ' resources-download__page-btn--active' : '') + '">' + p + '</button>'; }
        html += '<button class="resources-download__page-btn' + (currentPage === totalPages ? ' resources-download__page-btn--disabled' : '') + '">\u2192</button>';
        pag.innerHTML = html;
        pag.querySelectorAll('.resources-download__page-btn').forEach(function(btn, idx) {
          btn.addEventListener('click', function() {
            if (idx === 0) { currentPage--; renderPage(); return; }
            if (idx === totalPages + 1) { currentPage++; renderPage(); return; }
            currentPage = idx; renderPage();
          });
        });
      } else if (pag) { pag.innerHTML = ''; }

      // Sync active states
      var filterBtns = section.querySelectorAll('[data-resources-filter]');
      filterBtns.forEach(function(b) { b.classList.remove('resources-download__nav-btn--active'); });
      var activeBtns = section.querySelectorAll('[data-resources-filter="' + currentFilter + '"]');
      activeBtns.forEach(function(b) { b.classList.add('resources-download__nav-btn--active'); });
    }

    function setFilter(f) {
      currentFilter = f;
      currentPage = 1;
      renderPage();
    }

    function resetSearch() {
      if (searchDesktop) searchDesktop.value = '';
      if (searchMobile) searchMobile.value = '';
      if (resetDesktop) resetDesktop.classList.remove('resources-download__search-reset--visible');
      if (resetMobile) resetMobile.classList.remove('resources-download__search-reset--visible');
      clearTimeout(searchTimer);
      searchQuery = '';
      currentPage = 1;
      renderPage();
    }

    function openDrawer() {
      if (drawer) drawer.classList.add('resources-download__drawer--open');
      if (drawerOverlay) drawerOverlay.classList.add('resources-download__drawer-overlay--open');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (drawer) drawer.classList.remove('resources-download__drawer--open');
      if (drawerOverlay) drawerOverlay.classList.remove('resources-download__drawer-overlay--open');
      document.body.style.overflow = '';
    }

    // Init
    updateCounts();
    renderPage();

    // Nav clicks (desktop sidebar)
    if (nav) nav.addEventListener('click', function(e) { var b = e.target.closest('[data-resources-filter]'); if (b) setFilter(b.getAttribute('data-resources-filter')); });
    // Nav clicks (mobile drawer)
    if (drawerNav) drawerNav.addEventListener('click', function(e) { var b = e.target.closest('[data-resources-drawer-filter]'); if (b) { setFilter(b.getAttribute('data-resources-filter')); closeDrawer(); } });
    // Search (with debounce)
    var searchTimer;
    function handleSearch(val) {
      searchQuery = val.trim();
      // Sync inputs immediately
      if (searchDesktop && document.activeElement !== searchDesktop) searchDesktop.value = searchQuery;
      if (searchMobile && document.activeElement !== searchMobile) searchMobile.value = searchQuery;
      // Toggle reset buttons immediately
      var showReset = searchQuery.length > 0;
      if (resetDesktop) resetDesktop.classList.toggle('resources-download__search-reset--visible', showReset);
      if (resetMobile) resetMobile.classList.toggle('resources-download__search-reset--visible', showReset);
      // Debounce the page render
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function() { renderPage(); }, 200);
    }
    if (searchDesktop) searchDesktop.addEventListener('input', function() { handleSearch(this.value); });
    if (searchMobile) searchMobile.addEventListener('input', function() { handleSearch(this.value); });
    // Reset
    if (resetDesktop) resetDesktop.addEventListener('click', resetSearch);
    if (resetMobile) resetMobile.addEventListener('click', resetSearch);
    // Drawer
    if (filterToggle) filterToggle.addEventListener('click', openDrawer);
    if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
    if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solutions-function"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var tabs = document.querySelectorAll('[data-function-filter]');
    var cards = document.querySelectorAll('[data-function-card]');
    if (!tabs.length || !cards.length) return;

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var filter = tab.getAttribute('data-function-filter');
        tabs.forEach(function(t) { t.classList.remove('solutions-function__tab--active'); });
        tab.classList.add('solutions-function__tab--active');
        cards.forEach(function(card) {
          if (filter === 'all' || card.getAttribute('data-function-category') === filter) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solutions-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-hero-root]');
    if (!root) return;
    var slides = root.querySelectorAll('[data-hero-slide]');
    var dots = root.querySelectorAll('[data-hero-dot]');
    if (!slides.length || slides.length < 2) return;

    var current = 0;
    var total = slides.length;
    var autoplay = root.getAttribute('data-hero-autoplay') === 'true';
    var interval = parseInt(root.getAttribute('data-hero-interval')) || 5000;
    var timer = null;

    function goTo(idx) {
      if (idx === current) return;
      slides[current].classList.remove('solutions-hero__slide--active');
      dots[current] && dots[current].classList.remove('solutions-hero__dot--active');
      current = (idx + total) % total;
      slides[current].classList.add('solutions-hero__slide--active');
      dots[current] && dots[current].classList.add('solutions-hero__dot--active');
      resetTimer();
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }
    function resetTimer() {
      if (timer) clearInterval(timer);
      if (autoplay) timer = setInterval(next, interval);
    }

    var prevBtn = root.querySelector('[data-hero-prev]');
    var nextBtn = root.querySelector('[data-hero-next]');
    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goTo(parseInt(dot.getAttribute('data-hero-dot')));
      });
    });

    resetTimer();
    root.addEventListener('mouseenter', function() { if (timer) clearInterval(timer); });
    root.addEventListener('mouseleave', resetTimer);

    document.addEventListener('visibilitychange', function() {
      if (document.hidden) { if (timer) clearInterval(timer); }
      else resetTimer();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solutions-industry"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-industry-root]');
    if (!root) return;
    var tabs = root.querySelectorAll('[data-industry-tab]');
    var panels = root.querySelectorAll('[data-industry-panel]');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var idx = tab.getAttribute('data-industry-tab');
        tabs.forEach(function(t) { t.classList.remove('solutions-industry__tab--active'); });
        tab.classList.add('solutions-industry__tab--active');
        panels.forEach(function(p) { p.classList.remove('solutions-industry__panel--active'); });
        var panel = root.querySelector('[data-industry-panel=\"' + idx + '\"]');
        if (panel) panel.classList.add('solutions-industry__panel--active');

        // Auto-scroll to keep active tab visible
        tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solutions-scenario"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var grid = document.querySelector('[data-scenario-grid]');
    var dots = document.querySelectorAll('[data-scenario-page]');
    if (!grid || !dots.length) return;

    var cards = grid.querySelectorAll('[data-scenario-card]');
    var perPage = parseInt(grid.getAttribute('data-per-page')) || 8;
    var current = 0;
    var total = Math.ceil(cards.length / perPage);

    function showPage(idx) {
      current = idx;
      cards.forEach(function(c, i) {
        var page = Math.floor(i / perPage);
        c.style.display = page === idx ? '' : 'none';
      });
      dots.forEach(function(d) {
        d.classList.toggle('solutions-scenario__dot--active', parseInt(d.getAttribute('data-scenario-page')) === idx);
      });
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        showPage(parseInt(dot.getAttribute('data-scenario-page')));
      });
    });

    showPage(0);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-counter"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var counters = document.querySelectorAll('.stats-counter');
    if (!counters.length) return;

    counters.forEach(function(root) {
      var items = root.querySelectorAll('.stat-item__value[data-count]');
      if (!items.length) return;

      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          if (el.dataset.animated) return;
          el.dataset.animated = '1';
          observer.unobserve(el);

          var target = parseInt(el.dataset.count, 10);
          if (isNaN(target) || target <= 0) return;

          // Respect user's reduced motion preference — show final value immediately
          if (prefersReducedMotion) {
            el.textContent = target.toLocaleString();
            return;
          }

          var duration = 2000;
          var start = performance.now();
          var rafId;

          function step(currentTime) {
            var elapsed = currentTime - start;
            var progress = Math.min(elapsed / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            var current = Math.round(eased * target);
            el.textContent = current.toLocaleString();
            if (progress < 1) {
              rafId = requestAnimationFrame(step);
            } else {
              el.textContent = target.toLocaleString();
            }
          }
          rafId = requestAnimationFrame(step);

          // Store rafId on element for potential cleanup
          el._statsRafId = rafId;
        });
      }, { threshold: 0.2 });

      items.forEach(function(el) {
        observer.observe(el);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tech-engines"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-tech-carousel]');
    if (!root) return;

    var track = root.querySelector('[data-tech-track]');
    var grid = track.querySelector('.tech-engines__grid');
    var realSlides = Array.from(root.querySelectorAll('[data-tech-slide]'));
    var total = realSlides.length;
    if (total < 2) return;

    var mql = window.matchMedia('(max-width: 640px)');
    var allSlides = realSlides.slice(); // starts as real slides only
    var current = 0;
    var busy = false;
    var carouselActive = false;

    // ── Clone helpers ──
    function createClones() {
      var firstClone = realSlides[0].cloneNode(true);
      firstClone.setAttribute('data-tech-clone', '');
      var lastClone = realSlides[total - 1].cloneNode(true);
      lastClone.setAttribute('data-tech-clone', '');
      grid.insertBefore(lastClone, realSlides[0]);
      grid.appendChild(firstClone);
      allSlides = Array.from(root.querySelectorAll('[data-tech-slide]'));
    }

    function removeClones() {
      root.querySelectorAll('[data-tech-clone]').forEach(function(c) { c.remove(); });
      allSlides = realSlides.slice();
    }

    function cardW() {
      return allSlides[0] ? allSlides[0].offsetWidth : 300;
    }

    function gapPx() {
      return parseFloat(getComputedStyle(track).gap) || 16;
    }

    function offsetAt(i) {
      return -(i * (cardW() + gapPx()));
    }

    function realIdx() {
      if (current === 0) return total - 1;
      if (current === total + 1) return 0;
      return current - 1;
    }

    function applyTransform(animate) {
      if (!carouselActive) return;
      track.style.transition = animate
        ? 'transform 0.45s cubic-bezier(0.25, 0.1, 0.25, 1)'
        : 'none';
      track.style.transform = 'translateX(' + offsetAt(current) + 'px)';
    }

    function updateUI() {
      if (!carouselActive) return;
      var ri = realIdx();
      root.querySelectorAll('[data-tech-dot]').forEach(function(d, i) {
        d.classList.toggle('tech-engines__dot--active', i === ri);
      });
    }

    // ── Seamless wrap after animation ends ──
    track.addEventListener('transitionend', function() {
      if (!carouselActive) return;
      busy = false;
      if (current === 0) {
        current = total;
        applyTransform(false);
        updateUI();
      } else if (current === total + 1) {
        current = 1;
        applyTransform(false);
        updateUI();
      }
    });

    // ── Step ──
    function step(dir) {
      if (busy || !carouselActive) return;
      busy = true;
      current += dir;
      applyTransform(true);
      updateUI();
    }

    // ── Dots ──
    root.querySelectorAll('[data-tech-dot]').forEach(function(d) {
      d.addEventListener('click', function() {
        if (busy || !carouselActive) return;
        busy = true;
        current = parseInt(d.getAttribute('data-tech-dot'), 10) + 1;
        applyTransform(true);
        updateUI();
      });
    });

    // ── Touch swipe ──
    var touchX = 0;
    track.addEventListener('touchstart', function(e) {
      if (!carouselActive) return;
      touchX = e.touches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchend', function(e) {
      if (busy || !carouselActive) return;
      var diff = touchX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        step(diff > 0 ? 1 : -1);
      }
    });

    // ── Activate / deactivate ──
    function activate() {
      if (carouselActive) return;
      carouselActive = true;
      createClones();
      current = 1; // real slide 0
      applyTransform(false);
      updateUI();
    }

    function deactivate() {
      if (!carouselActive) return;
      carouselActive = false;
      track.style.transition = 'none';
      track.style.transform = '';
      removeClones();
      current = 0;
      busy = false;
    }

    function onResize() {
      if (mql.matches) {
        activate();
      } else {
        deactivate();
      }
      // Recalculate position if active
      if (carouselActive) {
        applyTransform(false);
        updateUI();
      }
    }

    // ── Init ──
    if (mql.matches) activate();

    mql.addEventListener('change', function() {
      onResize();
    });

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(onResize, 150);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  var Honeycomb = {
    init: function(section) {
      var container = section.querySelector('[data-honeycomb]');
      if (!container) return;

      var cells = container.querySelectorAll(':scope > .honeycomb__cell');
      if (!cells.length) return;

      /* ════════════════════════════════════════════
         Row-major grid coordinates (fills width first)
         ════════════════════════════════════════════ */
      function generateGrid(count) {
        var coords = [];
        var col = 0, row = 0;
        while (coords.length < count) {
          coords.push([col, row]);
          col++;
          if (col >= _colsPerRow) { col = 0; row++; }
        }
        return coords;
      }

      /* Width-based column count — ensures row fits in availW */
      var _colsPerRow = 8;
      function setCols(availW, cellW, gap) {
        /* Max cols such that all cells fit within availW */
        _colsPerRow = Math.max(2, 1 + Math.floor((availW - cellW) / (cellW * 0.75 * gap)));
      }

      function coordToPixel(col, row, W, H, gap) {
        return {
          left: col * (W * 3/4 * gap),
          top:  row * H * gap + (col & 1 ? H/2 * gap : 0)
        };
      }

      function getWidth() {
        /* Parent content width (excludes padding) — works on init + resize */
        var p = container.parentElement;
        if (p && p.clientWidth) {
          var cs = getComputedStyle(p);
          var w = p.clientWidth - (parseFloat(cs.paddingLeft)||0) - (parseFloat(cs.paddingRight)||0);
          if (w > 50) return w;
        }
        /* Fallbacks */
        return (container.getBoundingClientRect().width | 0)
            || section.clientWidth
            || window.innerWidth;
      }

      function layout() {
        /* Re-query cells — DOM may have been replaced by editor */
        var cells = container.querySelectorAll(':scope > .honeycomb__cell');
        if (!cells.length) { _attempts = 0; return; }

        var cw = getWidth();
        /* Cap to container's own max-width (never wider than CSS allows) */
        var cs = getComputedStyle(container);
        var maxW = parseFloat(cs.maxWidth);
        if (maxW && cw > maxW) cw = maxW;
        if (!cw || cw < 100) {
          if (++_attempts < 15) setTimeout(tryLayout, 300);
          return;
        }
        _attempts = 0;

        var targetCols = cw >= 1024 ? 4 : cw >= 640 ? 3 : 2;
        var W = Math.floor(cw / (targetCols * 0.8));
        W = Math.max(80, Math.min(W, 180));
        var H = W * 0.866;
        var gap = 1.04;

        setCols(cw, W, gap);
        var coords = generateGrid(cells.length);

        /* Bounding box — grid starts at (0,0) */
        var maxCol = 0, maxRow = 0;
        coords.forEach(function(c) {
          maxCol = Math.max(maxCol, c[0]);
          maxRow = Math.max(maxRow, c[1]);
        });
        var firstPixel = coordToPixel(0, 0, W, H, gap);
        var lastPixel  = coordToPixel(maxCol, maxRow, W, H, gap);
        var calcW = lastPixel.left - firstPixel.left + W;
        var calcH = lastPixel.top  - firstPixel.top  + H;
        /* Safety: never exceed available width */
        if (calcW > cw) calcW = cw;
        container.style.width  = calcW + 'px';
        container.style.height = calcH + 'px';

        cells.forEach(function(cell, i) {
          var c = coords[i];
          var pos = coordToPixel(c[0], c[1], W, H, gap);
          cell.style.width  = W + 'px';
          cell.style.height = H + 'px';
          cell.style.left   = (pos.left - firstPixel.left) + 'px';
          cell.style.top    = (pos.top  - firstPixel.top)  + 'px';
        });

        /* Bind click on linked cells */
        cells.forEach(function(cell) {
          if (cell._hcBound) return;
          cell._hcBound = true;
          var link = cell.getAttribute('data-link');
          if (link) {
            cell.addEventListener('click', function() {
              window.location.href = link;
            });
          }
        });
      }

      /* ── Repeated layout attempts until successful ── */
      var _attempts = 0;
      var sectionId = section.getAttribute('data-section-id');
      function tryLayout() {
        /* Always refresh container — DOM may have been replaced */
        var fresh = document.querySelector('[data-section-id="' + sectionId + '"] [data-honeycomb]');
        if (fresh) container = fresh;
        if (!container) { _attempts = 0; return; }
        var cells = container.querySelectorAll(':scope > .honeycomb__cell');
        if (!cells.length) { _attempts = 0; return; }
        if (!getWidth() || getWidth() < 100) {
          if (++_attempts < 20) setTimeout(tryLayout, 300);
          return;
        }
        _attempts = 0;
        layout();
      }

      /* Initial run */
      setTimeout(tryLayout, 200);

      /* Resize */
      var resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(tryLayout, 150);
      });

      /* ── MutationObserver limited to this section ── */
      if (window.MutationObserver) {
        var observer = new MutationObserver(function() {
          setTimeout(tryLayout, 150);
        });
        observer.observe(container, { childList: true, subtree: true });
      }

      /* ── Shopify Theme Editor events (backup) ── */
      document.addEventListener('shopify:section:load', function(e) {
        if (e.target.getAttribute('data-section-id') === sectionId) {
          container = e.target.querySelector('[data-honeycomb]');
          if (container) setTimeout(tryLayout, 200);
        }
      });
      document.addEventListener('shopify:block:select', function(e) {
        var bs = e.target.closest('[data-section-id="' + sectionId + '"]');
        if (bs) setTimeout(tryLayout, 200);
      });
      document.addEventListener('shopify:block:deselect', function(e) {
        var bs = e.target.closest('[data-section-id="' + sectionId + '"]');
        if (bs) setTimeout(tryLayout, 200);
      });
    }
  };

  /* Bootstrap */
  var section = (document.currentScript && document.currentScript.closest('.section-logo-wall'))
    || document.querySelector('.section-logo-wall');
  if (section) Honeycomb.init(section);

  } catch(e) { console.error(e); }
})();
})();
